<template>
  <Drawer :drawer="drawer" title="核销记录" :size="1200" @close="handleClose">
    <div class="log-body">
      <BaseTable
        :height="height"
        :tableData="tableData"
        :isPager="false"
        :loading="loading"
      >
        <template slot="index" slot-scope="row">
          {{ tableData.columns.indexOf(row.scope) + 1 }}
        </template>
      </BaseTable>
    </div>
  </Drawer>
</template>
<script>
import {
  getInvoicePaymentVerifyDetails,
  getInvoicePaymentVerifyDetailsBySupplier } from '@/api/fee'

const BaseTable = () => import('@/components/table/BaseTable.vue')
const Drawer = () => import('@/components/drawer/Drawer')
export default {
  components: { BaseTable, Drawer },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    typeActive: { //  0 客户 1 代理
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'paymentAccountName',
            label: '付款账户',
            width: ''
          },
          {
            filed: 'bankAccountNumber',
            label: '银行账户',
            width: ''
          },
          {
            filed: 'bankName',
            label: '银行',
            width: ''
          },
          {
            filed: 'receiptOn',
            label: '到账日期',
            width: ''
          },
          {
            filed: 'createdOn',
            label: '创建日期',
            width: ''
          },
          {
            filed: 'receivedAmount',
            label: '到账金额',
            width: ''
          },
          {
            filed: 'verifedAmount',
            label: '核销金额',
            width: ''
          }
        ],
        columns: [],
        total: 0
      },
      height: 0
    }
  },
  watch: {
    async drawer(val) {
      if (val) {
        await this.getLists()
        this.$nextTick(() => {
          this.height = document.querySelector('.log-body').offsetHeight - 100
        })
      }
    }
  },
  methods: {
    getLists() {
      this.loading = true
      if (!this.typeActive) {
          getInvoicePaymentVerifyDetails({
          invoiceId: this.rowData.id
        }).then((res) => {
          if (res.success) {
            this.loading = false
            this.tableData.columns = res.data
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      } else {
        getInvoicePaymentVerifyDetailsBySupplier({
          invoiceId: this.rowData.id
        }).then((res) => {
          if (res.success) {
            this.loading = false
            this.tableData.columns = res.data
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      }
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.log-body {
  width: calc(100% - 40px);
  height: 100%;
  margin: 20px auto 20px;
}
</style>
